import React, { useState } from 'react';
import CallHistoryTable from 'Components/CallHistories/CallHistoryTable';

const CallHistories = () => {
    return (
        <React.Fragment>
            <CallHistoryTable />
        </React.Fragment>
    );
};

export default CallHistories;